import { render, staticRenderFns } from "./trainee.create.vue?vue&type=template&id=2596267a&scoped=true&"
import script from "./trainee.create.vue?vue&type=script&lang=ts&"
export * from "./trainee.create.vue?vue&type=script&lang=ts&"
import style0 from "./trainee.create.vue?vue&type=style&index=0&id=2596267a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2596267a",
  null
  
)

export default component.exports